import React, { useEffect, useState } from 'react'
import { ITurnoverLog } from '../../types/turnoverLog.type';
import dayjs from 'dayjs';
import { api } from '../../api/api';
import { Space, Table, Typography } from 'antd';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const TurnoverLogs = () => {
    const [logs, setLogs] = useState<ITurnoverLog[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [dateRange, setDateRange] = useState<
        [dayjs.Dayjs, dayjs.Dayjs] | undefined
    >([dayjs().startOf("month"), dayjs().endOf("month")]);

    const handleRangeChange = (dates: any) => {
        if (dates) {
            setDateRange([dates[0], dates[1]]);
        } else {
            setDateRange(undefined);
        }
    };
    const fetchLogs = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/stats/turnover/logs/`, {
                params: {
                    page,
                    limit: pageSize,
                    startDate: dateRange?.[0]?.format("DD.MM.YYYY"),
                    endDate: dateRange?.[1]?.format("DD.MM.YYYY"),
                }
            });
            setLogs(response.data.logs);
            setTotal(response.data.total);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [page, pageSize, dateRange]);

    const columns = [
        {
            title: "Дата",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Оборот до",
            dataIndex: "turnoverBefore",
            key: "turnoverBefore",
        },
        {
            title: "Оборот после",
            dataIndex: "turnoverAfter",
            key: "turnoverAfter",
        },
        {
            title: "Описание",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Сумма",
            dataIndex: "amount",
            key: "amount",
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Typography.Title level={2}>Отчеты оборота</Typography.Title>
            <Space style={{ marginBottom: 16, marginTop: 16 }}>
                <RangePicker
                    onChange={handleRangeChange}
                    placeholder={["Начало", "Конец"]}
                    format="DD.MM.YYYY"
                    value={dateRange}
                />
            </Space>
            <Table
                loading={loading}
                columns={columns}
                dataSource={logs}
                rowKey={(record) => record._id}
                pagination={{
                    current: page,
                    total: total,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                        setPage(page);
                        if (size !== pageSize) setPageSize(size!);
                    },
                }}
                scroll={{ x: "max-content" }}
            />
        </div>
    )
}

export default TurnoverLogs